import { Box, CircularProgress, styled } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  paddingTop: theme.spacing(20),
}));

export function LoadingPage() {
  return (
    <Wrapper data-testid={"loadingSpinner"}>
      <CircularProgress color="inherit" />
    </Wrapper>
  );
}
